// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Form Enhancement Styles - Smart Data Pre-population & UI Polish */

/* Audit form radius scale. Deliberately restrained: inputs and buttons are
   softened, never pill-shaped, and cards stay only slightly rounder than the
   controls they contain. Defined on :root so the Audit Process page CSS (the
   certificate preview card, the standard tabs) can share the same scale
   without living inside .audit-form-shell. */
:root {
  --audit-r-input: 8px;
  --audit-r-button: 8px;
  --audit-r-card: 12px;
  --audit-r-badge: 6px;
}

.audit-form-shell {
  --audit-accent: #1a767e;
  --audit-accent-dark: #0d5962;
  --audit-surface: #ffffff;
  --audit-surface-soft: linear-gradient(180deg, #fbfdff 0%, #f4f8fb 100%);
  --audit-border: #d8e1ec;
  --audit-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);
}

.audit-form-shell .form-control,
.audit-form-shell .form-select,
.audit-form-shell textarea {
  border-radius: var(--audit-r-input);
  border: 1px solid var(--audit-border);
  background: #fff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.audit-form-shell textarea.form-control {
  min-height: 96px;
}

.audit-form-shell .form-control:focus,
.audit-form-shell .form-select:focus,
.audit-form-shell textarea:focus {
  border-color: var(--audit-accent);
  box-shadow: 0 0 0 0.2rem rgba(26, 118, 126, 0.12);
}

/* Bootstrap's own .form-control.is-invalid is a single-class selector, so the
   two-class .audit-form-shell .form-control rule above would otherwise win and
   the invalid state would render with a normal grey border. Restate it here at
   matching specificity. */
.audit-form-shell .form-control.is-invalid,
.audit-form-shell .form-select.is-invalid,
.audit-form-shell textarea.is-invalid {
  border-color: #dc3545;
  background-image: none;
  padding-right: 0.75rem;
}

.audit-form-shell .form-control.is-invalid:focus,
.audit-form-shell .form-select.is-invalid:focus,
.audit-form-shell textarea.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
}

/* Anchors the scroll-to-first-error jump and gives the whole group, not just
   the control, a visible invalid state. */
.field-group--invalid {
  scroll-margin-top: 96px;
}

.field-group--invalid .form-label-enhanced {
  color: #b02a37;
}

.audit-form-shell .btn {
  border-radius: var(--audit-r-button);
}

.audit-form-shell .card,
.audit-form-shell .accordion-item {
  border-radius: var(--audit-r-card);
  border-color: #dfe7f0;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.audit-form-shell .table {
  --bs-table-bg: transparent;
}

/* Form section grouping */
.form-section {
  background: var(--audit-surface-soft);
  border: 1px solid #dfe7f0;
  border-left: 4px solid var(--audit-accent);
  border-radius: var(--audit-r-card);
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

/* Section titles used to be prefixed by a 4x4px dot (a ::before bullet), which
   read as a stray speck rather than as structure. The dot is replaced by a rule
   that runs from the title to the edge of the form, so each heading visibly
   splits one section from the next.

   The rule trails the title rather than sitting above it as a border: a top
   border would need first-child handling in every form that opens with a
   SectionHeader, and would double up against the scope banner. A trailing rule
   has no such edge cases and works at any container width. */
.form-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a767e;
  margin: 32px 0 16px;
  display: flex;
  align-items: center;
  gap: 14px;
}

/* A form that opens on a section header should not start with a 32px gap. */
.form-section-title:first-child {
  margin-top: 0;
}

.form-section-title::after {
  content: '';
  flex: 1 1 auto;
  min-width: 24px;
  height: 1px;
  background: linear-gradient(90deg, rgba(26, 118, 126, 0.3) 0%, rgba(26, 118, 126, 0.06) 100%);
}

.template-aligned-card {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  padding: 16px 18px;
  border: 1px solid rgba(26, 118, 126, 0.18);
  border-radius: var(--audit-r-card);
  background:
    radial-gradient(circle at top right, rgba(32, 176, 166, 0.16), transparent 38%),
    linear-gradient(135deg, #f8fffe 0%, #eef8f7 100%);
  box-shadow: 0 14px 28px rgba(15, 89, 98, 0.07);
}

.template-aligned-card__eyebrow {
  color: #0d5962;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.template-aligned-card__title {
  margin-top: 4px;
  color: #173f45;
  font-size: 1rem;
  font-weight: 800;
}

.template-aligned-card__copy {
  margin-top: 4px;
  color: #5c6f75;
  font-size: 0.78rem;
  line-height: 1.5;
}

.change-option-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.change-option-chip {
  display: block;
  min-height: 44px;
  padding: 10px 12px;
  border: 1px solid #dbe6ed;
  border-radius: var(--audit-r-input);
  background: #ffffff;
  color: #425466;
  cursor: pointer;
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}

.change-option-chip:hover {
  transform: translateY(-1px);
  border-color: rgba(26, 118, 126, 0.35);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);
}

.change-option-chip.is-selected {
  border-color: #1a767e;
  background: linear-gradient(135deg, rgba(26, 118, 126, 0.12), rgba(32, 176, 166, 0.08));
  box-shadow: 0 0 0 3px rgba(26, 118, 126, 0.09);
}

.change-option-chip .form-check {
  min-height: 0;
}

.change-option-chip .form-check-input {
  margin-top: 0.15rem;
  accent-color: #1a767e;
}

.change-option-chip .form-check-label {
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.35;
}

@media (max-width: 768px) {
  .template-aligned-card,
  .change-option-grid {
    grid-template-columns: 1fr;
  }

  .template-aligned-card {
    flex-direction: column;
  }
}

/* Field group styling */
.field-group {
  margin-bottom: 16px;
}

.field-group.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 992px) {
  .field-group.two-column {
    grid-template-columns: 1fr;
  }
}

.field-group.three-column {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
}

@media (max-width: 992px) {
  .field-group.three-column {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 576px) {
  .field-group.three-column {
    grid-template-columns: 1fr;
  }
}

/* Form label styling */
.form-label-enhanced {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  color: #212529;
  margin-bottom: 8px;
}

.required-indicator {
  color: #dc3545;
  font-weight: 700;
  font-size: 14px;
}

.optional-indicator {
  color: #6c757d;
  font-size: 12px;
  font-style: italic;
  margin-left: auto;
}

.field-hint {
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
  display: block;
  font-style: italic;
}

/* Input field improvements */
.form-control-enhanced {
  border-color: #dee2e6;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control-enhanced:focus {
  border-color: #1a767e;
  box-shadow: 0 0 0 0.2rem rgba(26, 118, 126, 0.15);
}

.form-control-enhanced.is-invalid {
  border-color: #dc3545;
}

.form-control-enhanced.is-invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
}

.form-control-enhanced.is-valid {
  border-color: #198754;
}

.form-control-enhanced.is-valid:focus {
  box-shadow: 0 0 0 0.2rem rgba(25, 135, 84, 0.15);
}

/* Textarea improvements */
.form-control-enhanced.textarea {
  resize: vertical;
  min-height: 100px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
}

/* Row management styling */
.dynamic-row {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: var(--audit-r-card);
  padding: 16px;
  margin-bottom: 12px;
  transition: box-shadow 0.2s, border-color 0.2s;
}

.dynamic-row:hover {
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  border-color: rgba(26, 118, 126, 0.28);
}

.dynamic-row-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}

.dynamic-row-index {
  font-weight: 600;
  color: #6c757d;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dynamic-row-actions {
  display: flex;
  gap: 8px;
}

.btn-remove-row {
  padding: 4px 8px;
  font-size: 12px;
  color: #dc3545;
  border-color: #dc3545;
}

.btn-remove-row:hover {
  background: #dc3545;
  color: white;
}

/* Accordion improvements for multi-part forms */
.accordion-enhanced {
  border: 1px solid #dee2e6;
  border-radius: var(--audit-r-card);
  overflow: hidden;
}

.accordion-enhanced .accordion-item {
  border: none;
  border-bottom: 1px solid #dee2e6;
}

.accordion-enhanced .accordion-item:last-child {
  border-bottom: none;
}

.accordion-enhanced .accordion-button {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #212529;
  font-weight: 600;
  border: none;
  border-radius: 0;
}

.accordion-enhanced .accordion-button:focus {
  border-color: transparent;
  box-shadow: inset 0 0 0 0.25rem rgba(26, 118, 126, 0.15);
}

.accordion-enhanced .accordion-button:not(.collapsed) {
  background: linear-gradient(135deg, #1a767e 0%, #0d5962 100%);
  color: white;
}

.accordion-enhanced .accordion-body {
  padding: 20px;
  background: #fff;
}

/* Checklist improvements */
.checklist-item {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 16px;
  align-items: start;
  padding: 12px 0;
  border-bottom: 1px solid #e9ecef;
}

.checklist-item:last-child {
  border-bottom: none;
}

.checklist-label {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  white-space: normal;
  word-break: break-word;
}

.checklist-options {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.checklist-radio {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.checklist-radio input[type='radio'] {
  cursor: pointer;
  accent-color: #1a767e;
}

.checklist-details {
  grid-column: 1 / -1;
  margin-top: 8px;
}

.checklist-details textarea {
  font-size: 12px;
  resize: vertical;
  min-height: 60px;
}

/* Table improvements */
.table-enhanced {
  margin: 0;
  font-size: 13px;
}

.table-enhanced thead {
  background: linear-gradient(135deg, #1a767e 0%, #0d5962 100%);
  color: white;
}

.table-enhanced thead th {
  border: none;
  font-weight: 600;
  padding: 12px;
  white-space: nowrap;
  text-align: center;
}

.table-enhanced tbody td {
  padding: 12px;
  border-color: #dee2e6;
  vertical-align: middle;
}

.table-enhanced tbody tr:hover {
  background: #f8f9fa;
}

.table-enhanced input[type='number'],
.table-enhanced input[type='text'],
.table-enhanced select {
  width: 100%;
  max-width: 120px;
  font-size: 13px;
}

/* Status badges for auto-populated fields */
.auto-populated-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #0d5962;
  background: #d1ecf1;
  padding: 2px 8px;
  border-radius: var(--audit-r-badge);
  margin-left: auto;
}

.auto-populated-badge::before {
  content: '✓';
}

/* Loading state */
.field-loading {
  position: relative;
  opacity: 0.6;
  pointer-events: none;
}

.field-loading::after {
  content: '';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: 2px solid #1a767e;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}

/* Modal improvements */
.modal-header-enhanced {
  background: linear-gradient(135deg, #1a767e 0%, #0d5962 100%);
  color: white;
  border-bottom: 2px solid #0d5962;
}

.modal-header-enhanced .modal-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.modal-header-enhanced .btn-close {
  filter: brightness(0) invert(1);
}

.audit-scope-banner {
  background: linear-gradient(135deg, rgba(26, 118, 126, 0.08) 0%, rgba(13, 89, 98, 0.14) 100%);
  border: 1px solid rgba(26, 118, 126, 0.14);
  border-radius: var(--audit-r-card);
  padding: 18px 20px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);
}

.audit-output-mode {
  margin: 0;
  padding: 18px;
  border: 1px solid rgba(26, 118, 126, 0.2);
  border-radius: var(--audit-r-card);
  background: linear-gradient(145deg, #fbfffe 0%, #f0faf9 100%);
  box-shadow: 0 10px 28px rgba(15, 89, 98, 0.06);
}

.audit-output-mode legend {
  float: none;
  width: auto;
  margin: 0 0 4px;
  color: #173f45;
  font-size: 0.9rem;
  font-weight: 800;
}

.audit-output-mode > p {
  margin: 0 0 14px;
  color: #64777c;
  font-size: 0.76rem;
}

.audit-output-mode__options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.audit-output-mode__option {
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: 10px;
  align-items: center;
  min-height: 84px;
  padding: 13px;
  border: 1px solid #d6e5e5;
  border-radius: var(--audit-r-input);
  background: #fff;
  cursor: pointer;
  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;
}

.audit-output-mode__option:hover {
  transform: translateY(-1px);
  border-color: #76bbb5;
}

.audit-output-mode__option.is-selected {
  border-color: #16887f;
  box-shadow: 0 0 0 3px rgba(22, 136, 127, 0.11), 0 8px 20px rgba(15, 89, 98, 0.08);
}

.audit-output-mode__option input {
  width: 17px;
  height: 17px;
  accent-color: #16887f;
}

.audit-output-mode__icon {
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: var(--audit-r-input);
  color: #166d68;
  background: #e5f5f3;
}

.audit-output-mode__option strong,
.audit-output-mode__option small {
  display: block;
}

.audit-output-mode__option strong { color: #1f3d42; font-size: 0.82rem; }
.audit-output-mode__option small { margin-top: 3px; color: #708287; font-size: 0.7rem; line-height: 1.4; }

.audit-output-mode__summary {
  margin-top: 12px;
  padding: 7px 10px;
  border-radius: var(--audit-r-badge);
  color: #17645f;
  background: rgba(22, 136, 127, 0.08);
  font-size: 0.72rem;
  font-weight: 700;
}

/* Split output: one tab per standard, each holding its own copy of the form. */
.audit-split-standards {
  margin: 0;
}

.audit-split-standards__tabs {
  gap: 2px;
  border-bottom: 1px solid #d6e5e5;
  flex-wrap: wrap;
}

.audit-split-standards__tabs .nav-link {
  border: 1px solid transparent;
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  padding: 8px 16px;
  color: #64777c;
  background: transparent;
  font-size: 0.78rem;
  font-weight: 700;
}

.audit-split-standards__tabs .nav-link:hover,
.audit-split-standards__tabs .nav-link:focus {
  color: #16887f;
  background: rgba(22, 136, 127, 0.08);
}

.audit-split-standards__tabs .nav-link.active {
  color: #16887f;
  background: #fff;
  border-color: #d6e5e5 #d6e5e5 transparent;
  box-shadow: 0 -2px 0 0 #16887f inset;
}

.audit-split-standards__hint {
  margin: 10px 0 0;
  color: #64777c;
  font-size: 0.72rem;
}

.audit-split-standards__hint strong {
  color: #17645f;
}

.audit-scope-banner__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
}

.audit-scope-banner__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--audit-accent-dark);
  margin-bottom: 6px;
}

.audit-scope-banner__title {
  color: #16323f;
  font-size: 1rem;
  font-weight: 700;
}

.audit-scope-banner__subtitle {
  font-size: 13px;
  color: #526273;
  max-width: 720px;
}

.audit-scope-banner__loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--audit-accent-dark);
  white-space: nowrap;
}

.audit-scope-banner__meta,
.audit-scope-banner__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.audit-scope-pill,
.audit-scope-chip {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 6px 12px;
  border-radius: var(--audit-r-badge);
  font-size: 12px;
  font-weight: 600;
}

.audit-scope-pill {
  background: #ffffff;
  color: #20414d;
  border: 1px solid rgba(26, 118, 126, 0.1);
}

.audit-scope-chip {
  background: rgba(26, 118, 126, 0.12);
  color: var(--audit-accent-dark);
}

.audit-form-select__menu {
  z-index: 12;
}

.audit-form-select__option--is-focused {
  background: rgba(26, 118, 126, 0.08) !important;
}

.audit-form-select__option--is-selected {
  background: var(--audit-accent) !important;
}

/* Save draft indicator */
.draft-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #ffc107;
  background: #fff3cd;
  padding: 8px 12px;
  border-radius: var(--audit-r-badge);
  margin-bottom: 12px;
}

.draft-indicator::before {
  content: '💾';
  font-size: 14px;
}

/* Field validation feedback */
.invalid-feedback,
.valid-feedback {
  display: block;
  font-size: 12px;
  margin-top: 4px;
}

.invalid-feedback {
  color: #dc3545;
}

.valid-feedback {
  color: #198754;
}

.audit-notes-editor {
  overflow: hidden;
  border: 1px solid #d8e1ec;
  border-radius: var(--audit-r-card);
  background: #fff;
}

.audit-notes-editor .ql-toolbar.ql-snow,
.audit-notes-editor .ql-container.ql-snow {
  border: 0;
}

.audit-notes-editor .ql-toolbar.ql-snow {
  border-bottom: 1px solid #e6edf3;
  background: #f7fbfb;
}

.audit-notes-editor .ql-editor {
  min-height: 240px;
  font-size: 0.92rem;
  line-height: 1.65;
}

.audit-evidence-panel {
  padding: 18px;
  border: 1px solid rgba(26, 118, 126, 0.2);
  border-radius: var(--audit-r-card);
  background: linear-gradient(145deg, #f8fcfc, #fff);
}

.audit-evidence-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 84px;
  color: #718096;
  border: 1px dashed #cbd8df;
  border-radius: var(--audit-r-input);
}

.audit-evidence-list {
  display: grid;
  gap: 8px;
}

.audit-evidence-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  border: 1px solid #e1eaee;
  border-radius: var(--audit-r-input);
  background: #fff;
}

.audit-evidence-item span {
  color: #718096;
  font-size: 0.76rem;
}

/* Responsive improvements */
@media (max-width: 576px) {
  .audit-output-mode__options { grid-template-columns: 1fr; }
  .audit-scope-banner {
    padding: 16px;
  }

  .audit-scope-banner__header {
    flex-direction: column;
  }

  .form-section {
    padding: 16px;
    margin-bottom: 16px;
  }

  .field-group.two-column {
    grid-template-columns: 1fr;
  }

  .checklist-item {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .checklist-options {
    justify-content: flex-start;
  }

  .dynamic-row {
    padding: 12px;
  }

  .table-enhanced input[type='number'],
  .table-enhanced input[type='text'],
  .table-enhanced select {
    max-width: 100%;
  }
}

/* Inline (non-modal) form action bar. The modal render keeps its actions on
   screen via Modal.Footer; the inline render is page-height, so Save is pinned
   here instead of living at the bottom of a very long scroll. */
.audit-form-sticky-actions {
  position: sticky;
  bottom: 0;
  z-index: 5;
  gap: 12px;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(6px);
  border-bottom-left-radius: var(--audit-r-card);
  border-bottom-right-radius: var(--audit-r-card);
  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.06);
}

@media (max-width: 576px) {
  .audit-form-sticky-actions {
    justify-content: flex-end !important;
  }
}

/* The enhanced label is a real <label> whenever it has a control to point at,
   so it should read as clickable. */
.form-label-enhanced label {
  cursor: pointer;
}
/* ── ISCC material tables ───────────────────────────────────────────────────
   Column COUNT varies by ISCC scheme (3 for CORSIA low-LUC, 4 for CORSIA, 5 for
   Japan-FIT, 7 for EU, 6 for Annex I -- see utils/isccMaterialSchemes), so widths
   cannot be pinned per nth-child as they were when there was a single fixed layout.
   Auto table layout lets each column size to its own content, with a min-width on
   the cells so a long GHG sentence wraps instead of collapsing a neighbour.

   Cells auto-grow vertically (AutoGrowTextarea), so a long value makes its row
   taller rather than being clipped inside a single-line input. .table-responsive
   still supplies horizontal scroll for the widest layout on a narrow screen. */
.audit-material-table {
  width: 100%;
}

.audit-material-table th,
.audit-material-table td {
  vertical-align: top;
  min-width: 130px;
  word-break: break-word;
}

.audit-material-table th {
  vertical-align: middle;
}

/* The trailing remove-row column is a fixed-size control, not content. */
.audit-material-table th.audit-material-table__action,
.audit-material-table td:last-child {
  min-width: 0;
  width: 1%;
  white-space: nowrap;
}

/* The shell gives every textarea a 96px floor, which would make each of these
   one-line cells nearly a hundred pixels tall. Height is driven by content via
   AutoGrowTextarea, so the floor and the manual resize grip both go. */
.audit-form-shell textarea.audit-material-cell-input,
textarea.audit-material-cell-input {
  min-height: 0;
  height: auto;
  padding: 0.3rem 0.5rem;
  overflow-y: hidden;
  resize: none;
  font-size: 0.82rem;
  line-height: 1.45;
}

/* Master-backed cells (Input/Output Material, Scope) render a react-select, whose
   menu is portalled to <body> so .table-responsive's overflow cannot clip it.
   Wrapping and sizing live in materialSelectStyles in DocumentFormModal, because
   react-select styles its own inner elements. */
.audit-material-select__control {
  background: #fff;
}

/* ── Compact select ─────────────────────────────────────────────────────────
   Sizes an AppSelect to match \`form-select-sm\` / \`form-control-sm\` siblings in a
   filter row. react-select styles its inner elements through emotion, whose classes
   are single-class selectors like these, so every declaration needs !important to
   win regardless of stylesheet order.

   The control's height comes from the value container's padding, not from the
   control's own padding — setting padding on the control does nothing visible.

   Replaces the control sizing that SalesReport/AchievementForm carried inline for
   Tom Select (the class name itself is deliberately not written out here — the
   removal guard in src/tomSelectRemoved.test.js greps for it, and cannot tell a
   historical comment from a live rule). Lives here rather than in that page so the next compact filter row
   uses one tested definition instead of a second copy. Exercised by
   e2e/tests/select-migration-smoke.spec.ts against the /dev/selects harness. */
.app-select--sm .mb-3 {
  margin-bottom: 0 !important;
}

.app-select--sm .app-select__control {
  min-height: calc(1.5em + 0.5rem + 2px) !important;
  font-size: 0.875rem !important;
  border-radius: 0.375rem !important;
}

.app-select--sm .app-select__value-container {
  padding: 0.125rem 0.5rem !important;
}

/* react-select draws a 20px SVG caret where Tom Select used a CSS triangle, and that
   icon alone made the control ~34px tall against the declared 31px min-height. Shrinking
   the icon is what actually lets min-height govern. */
.app-select--sm .app-select__indicator {
  padding: 0.125rem !important;
}

.app-select--sm .app-select__indicator svg {
  width: 14px;
  height: 14px;
}

/* react-select's input wrapper carries its own margin and vertical padding, which stacks
   on top of the value container's — without zeroing it the control renders ~34px and the
   31px min-height never governs. */
.app-select--sm .app-select__input-container {
  margin: 0 !important;
  padding: 0 !important;
}

.app-select--sm .app-select__menu {
  font-size: 0.875rem;
}

/* ── Truncated select menu footer ───────────────────────────────────────────
   Shown when a menu paints fewer options than matched (see makeMenuList in
   components/common/select/fieldChrome.jsx). Tom Select cut its list at 50 silently;
   this says so instead.

   Sticky rather than appended: MenuList is the scroll container, so a static footer
   would sit below 50 rows where nobody scrolls to find it. Pinned to the bottom edge, it
   is the one thing still visible after the list runs out — which is exactly when the
   reader is wondering where their client went.

   pointer-events: none so it can never swallow a click meant for the option beneath it
   as the list scrolls under it. */
.app-select__menu-truncation {
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 2px;
  padding: 7px 12px;
  border-top: 1px solid #e6edf3;
  background: linear-gradient(180deg, rgba(247, 251, 251, 0.92) 0%, #f7fbfb 42%);
  backdrop-filter: blur(2px);
  color: #64777c;
  font-size: 0.72rem;
  line-height: 1.45;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.app-select__menu-truncation strong {
  color: #17645f;
  font-weight: 700;
}

.app-select__menu-truncation-icon {
  flex: 0 0 auto;
  color: #16887f;
  opacity: 0.75;
}

/* The compact variant's menu is a size down, so its footer follows. */
.app-select--sm .app-select__menu-truncation {
  padding: 5px 10px;
  font-size: 0.68rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/formEnhancements.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;;;;6CAI6C;AAC7C;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,uEAAuE;EACvE,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;;;EAGE,mCAAmC;EACnC,qCAAqC;EACrC,gBAAgB;EAChB,oFAAoF;AACtF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA;;;0BAG0B;AAC1B;;;EAGE,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;;EAGE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;0CAC0C;AAC1C;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,kCAAkC;EAClC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,yBAAyB;EACzB,0CAA0C;EAC1C,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;;;;;;;6DAQ6D;AAC7D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,4EAA4E;AAC5E;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,WAAW;EACX,6FAA6F;AAC/F;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC;;qDAEmD;EACnD,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,6GAA6G;AAC/G;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uFAAuF;EACvF,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,iBAAiB;EACjB;;cAEY;AACd;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,0CAA0C;EAC5C;AACF;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6FAA6F;EAC7F,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,aAAa;EACb,yCAAyC;EACzC,kCAAkC;EAClC,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,oCAAoC,cAAc,EAAE,kBAAkB,EAAE;AACxE,mCAAmC,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAEzG;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;;EAEE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B,0BAA0B,EAAE;EAC1D;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;;gEAEgE;AAChE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,qCAAqC;EACrC,0BAA0B;EAC1B,8CAA8C;EAC9C,+CAA+C;EAC/C,8CAA8C;AAChD;;AAEA;EACE;IACE,oCAAoC;EACtC;AACF;;AAEA;oCACoC;AACpC;EACE,eAAe;AACjB;AACA;;;;;;;;;+EAS+E;AAC/E;EACE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;;EAEE,YAAY;EACZ,SAAS;EACT,mBAAmB;AACrB;;AAEA;;uEAEuE;AACvE;;EAEE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;gDAGgD;AAChD;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;+EAc+E;AAC/E;EACE,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;EACjD,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;sDAEsD;AACtD;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;mCAEmC;AACnC;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;kCAWkC;AAClC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,8EAA8E;EAC9E,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA,sEAAsE;AACtE;EACE,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["/* Form Enhancement Styles - Smart Data Pre-population & UI Polish */\n\n/* Audit form radius scale. Deliberately restrained: inputs and buttons are\n   softened, never pill-shaped, and cards stay only slightly rounder than the\n   controls they contain. Defined on :root so the Audit Process page CSS (the\n   certificate preview card, the standard tabs) can share the same scale\n   without living inside .audit-form-shell. */\n:root {\n  --audit-r-input: 8px;\n  --audit-r-button: 8px;\n  --audit-r-card: 12px;\n  --audit-r-badge: 6px;\n}\n\n.audit-form-shell {\n  --audit-accent: #1a767e;\n  --audit-accent-dark: #0d5962;\n  --audit-surface: #ffffff;\n  --audit-surface-soft: linear-gradient(180deg, #fbfdff 0%, #f4f8fb 100%);\n  --audit-border: #d8e1ec;\n  --audit-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);\n}\n\n.audit-form-shell .form-control,\n.audit-form-shell .form-select,\n.audit-form-shell textarea {\n  border-radius: var(--audit-r-input);\n  border: 1px solid var(--audit-border);\n  background: #fff;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.audit-form-shell textarea.form-control {\n  min-height: 96px;\n}\n\n.audit-form-shell .form-control:focus,\n.audit-form-shell .form-select:focus,\n.audit-form-shell textarea:focus {\n  border-color: var(--audit-accent);\n  box-shadow: 0 0 0 0.2rem rgba(26, 118, 126, 0.12);\n}\n\n/* Bootstrap's own .form-control.is-invalid is a single-class selector, so the\n   two-class .audit-form-shell .form-control rule above would otherwise win and\n   the invalid state would render with a normal grey border. Restate it here at\n   matching specificity. */\n.audit-form-shell .form-control.is-invalid,\n.audit-form-shell .form-select.is-invalid,\n.audit-form-shell textarea.is-invalid {\n  border-color: #dc3545;\n  background-image: none;\n  padding-right: 0.75rem;\n}\n\n.audit-form-shell .form-control.is-invalid:focus,\n.audit-form-shell .form-select.is-invalid:focus,\n.audit-form-shell textarea.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);\n}\n\n/* Anchors the scroll-to-first-error jump and gives the whole group, not just\n   the control, a visible invalid state. */\n.field-group--invalid {\n  scroll-margin-top: 96px;\n}\n\n.field-group--invalid .form-label-enhanced {\n  color: #b02a37;\n}\n\n.audit-form-shell .btn {\n  border-radius: var(--audit-r-button);\n}\n\n.audit-form-shell .card,\n.audit-form-shell .accordion-item {\n  border-radius: var(--audit-r-card);\n  border-color: #dfe7f0;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);\n}\n\n.audit-form-shell .table {\n  --bs-table-bg: transparent;\n}\n\n/* Form section grouping */\n.form-section {\n  background: var(--audit-surface-soft);\n  border: 1px solid #dfe7f0;\n  border-left: 4px solid var(--audit-accent);\n  border-radius: var(--audit-r-card);\n  padding: 20px;\n  margin-bottom: 20px;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);\n}\n\n/* Section titles used to be prefixed by a 4x4px dot (a ::before bullet), which\n   read as a stray speck rather than as structure. The dot is replaced by a rule\n   that runs from the title to the edge of the form, so each heading visibly\n   splits one section from the next.\n\n   The rule trails the title rather than sitting above it as a border: a top\n   border would need first-child handling in every form that opens with a\n   SectionHeader, and would double up against the scope banner. A trailing rule\n   has no such edge cases and works at any container width. */\n.form-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a767e;\n  margin: 32px 0 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n/* A form that opens on a section header should not start with a 32px gap. */\n.form-section-title:first-child {\n  margin-top: 0;\n}\n\n.form-section-title::after {\n  content: '';\n  flex: 1 1 auto;\n  min-width: 24px;\n  height: 1px;\n  background: linear-gradient(90deg, rgba(26, 118, 126, 0.3) 0%, rgba(26, 118, 126, 0.06) 100%);\n}\n\n.template-aligned-card {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n  padding: 16px 18px;\n  border: 1px solid rgba(26, 118, 126, 0.18);\n  border-radius: var(--audit-r-card);\n  background:\n    radial-gradient(circle at top right, rgba(32, 176, 166, 0.16), transparent 38%),\n    linear-gradient(135deg, #f8fffe 0%, #eef8f7 100%);\n  box-shadow: 0 14px 28px rgba(15, 89, 98, 0.07);\n}\n\n.template-aligned-card__eyebrow {\n  color: #0d5962;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.template-aligned-card__title {\n  margin-top: 4px;\n  color: #173f45;\n  font-size: 1rem;\n  font-weight: 800;\n}\n\n.template-aligned-card__copy {\n  margin-top: 4px;\n  color: #5c6f75;\n  font-size: 0.78rem;\n  line-height: 1.5;\n}\n\n.change-option-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.change-option-chip {\n  display: block;\n  min-height: 44px;\n  padding: 10px 12px;\n  border: 1px solid #dbe6ed;\n  border-radius: var(--audit-r-input);\n  background: #ffffff;\n  color: #425466;\n  cursor: pointer;\n  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;\n}\n\n.change-option-chip:hover {\n  transform: translateY(-1px);\n  border-color: rgba(26, 118, 126, 0.35);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06);\n}\n\n.change-option-chip.is-selected {\n  border-color: #1a767e;\n  background: linear-gradient(135deg, rgba(26, 118, 126, 0.12), rgba(32, 176, 166, 0.08));\n  box-shadow: 0 0 0 3px rgba(26, 118, 126, 0.09);\n}\n\n.change-option-chip .form-check {\n  min-height: 0;\n}\n\n.change-option-chip .form-check-input {\n  margin-top: 0.15rem;\n  accent-color: #1a767e;\n}\n\n.change-option-chip .form-check-label {\n  font-size: 0.78rem;\n  font-weight: 600;\n  line-height: 1.35;\n}\n\n@media (max-width: 768px) {\n  .template-aligned-card,\n  .change-option-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .template-aligned-card {\n    flex-direction: column;\n  }\n}\n\n/* Field group styling */\n.field-group {\n  margin-bottom: 16px;\n}\n\n.field-group.two-column {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 992px) {\n  .field-group.two-column {\n    grid-template-columns: 1fr;\n  }\n}\n\n.field-group.three-column {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 992px) {\n  .field-group.three-column {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 576px) {\n  .field-group.three-column {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Form label styling */\n.form-label-enhanced {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  color: #212529;\n  margin-bottom: 8px;\n}\n\n.required-indicator {\n  color: #dc3545;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.optional-indicator {\n  color: #6c757d;\n  font-size: 12px;\n  font-style: italic;\n  margin-left: auto;\n}\n\n.field-hint {\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 4px;\n  display: block;\n  font-style: italic;\n}\n\n/* Input field improvements */\n.form-control-enhanced {\n  border-color: #dee2e6;\n  font-size: 14px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.form-control-enhanced:focus {\n  border-color: #1a767e;\n  box-shadow: 0 0 0 0.2rem rgba(26, 118, 126, 0.15);\n}\n\n.form-control-enhanced.is-invalid {\n  border-color: #dc3545;\n}\n\n.form-control-enhanced.is-invalid:focus {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);\n}\n\n.form-control-enhanced.is-valid {\n  border-color: #198754;\n}\n\n.form-control-enhanced.is-valid:focus {\n  box-shadow: 0 0 0 0.2rem rgba(25, 135, 84, 0.15);\n}\n\n/* Textarea improvements */\n.form-control-enhanced.textarea {\n  resize: vertical;\n  min-height: 100px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n}\n\n/* Row management styling */\n.dynamic-row {\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: var(--audit-r-card);\n  padding: 16px;\n  margin-bottom: 12px;\n  transition: box-shadow 0.2s, border-color 0.2s;\n}\n\n.dynamic-row:hover {\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);\n  border-color: rgba(26, 118, 126, 0.28);\n}\n\n.dynamic-row-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.dynamic-row-index {\n  font-weight: 600;\n  color: #6c757d;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dynamic-row-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-remove-row {\n  padding: 4px 8px;\n  font-size: 12px;\n  color: #dc3545;\n  border-color: #dc3545;\n}\n\n.btn-remove-row:hover {\n  background: #dc3545;\n  color: white;\n}\n\n/* Accordion improvements for multi-part forms */\n.accordion-enhanced {\n  border: 1px solid #dee2e6;\n  border-radius: var(--audit-r-card);\n  overflow: hidden;\n}\n\n.accordion-enhanced .accordion-item {\n  border: none;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.accordion-enhanced .accordion-item:last-child {\n  border-bottom: none;\n}\n\n.accordion-enhanced .accordion-button {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  color: #212529;\n  font-weight: 600;\n  border: none;\n  border-radius: 0;\n}\n\n.accordion-enhanced .accordion-button:focus {\n  border-color: transparent;\n  box-shadow: inset 0 0 0 0.25rem rgba(26, 118, 126, 0.15);\n}\n\n.accordion-enhanced .accordion-button:not(.collapsed) {\n  background: linear-gradient(135deg, #1a767e 0%, #0d5962 100%);\n  color: white;\n}\n\n.accordion-enhanced .accordion-body {\n  padding: 20px;\n  background: #fff;\n}\n\n/* Checklist improvements */\n.checklist-item {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  gap: 16px;\n  align-items: start;\n  padding: 12px 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.checklist-item:last-child {\n  border-bottom: none;\n}\n\n.checklist-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.checklist-options {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.checklist-radio {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.checklist-radio input[type='radio'] {\n  cursor: pointer;\n  accent-color: #1a767e;\n}\n\n.checklist-details {\n  grid-column: 1 / -1;\n  margin-top: 8px;\n}\n\n.checklist-details textarea {\n  font-size: 12px;\n  resize: vertical;\n  min-height: 60px;\n}\n\n/* Table improvements */\n.table-enhanced {\n  margin: 0;\n  font-size: 13px;\n}\n\n.table-enhanced thead {\n  background: linear-gradient(135deg, #1a767e 0%, #0d5962 100%);\n  color: white;\n}\n\n.table-enhanced thead th {\n  border: none;\n  font-weight: 600;\n  padding: 12px;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.table-enhanced tbody td {\n  padding: 12px;\n  border-color: #dee2e6;\n  vertical-align: middle;\n}\n\n.table-enhanced tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.table-enhanced input[type='number'],\n.table-enhanced input[type='text'],\n.table-enhanced select {\n  width: 100%;\n  max-width: 120px;\n  font-size: 13px;\n}\n\n/* Status badges for auto-populated fields */\n.auto-populated-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #0d5962;\n  background: #d1ecf1;\n  padding: 2px 8px;\n  border-radius: var(--audit-r-badge);\n  margin-left: auto;\n}\n\n.auto-populated-badge::before {\n  content: '✓';\n}\n\n/* Loading state */\n.field-loading {\n  position: relative;\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.field-loading::after {\n  content: '';\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  border: 2px solid #1a767e;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n\n/* Modal improvements */\n.modal-header-enhanced {\n  background: linear-gradient(135deg, #1a767e 0%, #0d5962 100%);\n  color: white;\n  border-bottom: 2px solid #0d5962;\n}\n\n.modal-header-enhanced .modal-title {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.modal-header-enhanced .btn-close {\n  filter: brightness(0) invert(1);\n}\n\n.audit-scope-banner {\n  background: linear-gradient(135deg, rgba(26, 118, 126, 0.08) 0%, rgba(13, 89, 98, 0.14) 100%);\n  border: 1px solid rgba(26, 118, 126, 0.14);\n  border-radius: var(--audit-r-card);\n  padding: 18px 20px;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);\n}\n\n.audit-output-mode {\n  margin: 0;\n  padding: 18px;\n  border: 1px solid rgba(26, 118, 126, 0.2);\n  border-radius: var(--audit-r-card);\n  background: linear-gradient(145deg, #fbfffe 0%, #f0faf9 100%);\n  box-shadow: 0 10px 28px rgba(15, 89, 98, 0.06);\n}\n\n.audit-output-mode legend {\n  float: none;\n  width: auto;\n  margin: 0 0 4px;\n  color: #173f45;\n  font-size: 0.9rem;\n  font-weight: 800;\n}\n\n.audit-output-mode > p {\n  margin: 0 0 14px;\n  color: #64777c;\n  font-size: 0.76rem;\n}\n\n.audit-output-mode__options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.audit-output-mode__option {\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  gap: 10px;\n  align-items: center;\n  min-height: 84px;\n  padding: 13px;\n  border: 1px solid #d6e5e5;\n  border-radius: var(--audit-r-input);\n  background: #fff;\n  cursor: pointer;\n  transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.audit-output-mode__option:hover {\n  transform: translateY(-1px);\n  border-color: #76bbb5;\n}\n\n.audit-output-mode__option.is-selected {\n  border-color: #16887f;\n  box-shadow: 0 0 0 3px rgba(22, 136, 127, 0.11), 0 8px 20px rgba(15, 89, 98, 0.08);\n}\n\n.audit-output-mode__option input {\n  width: 17px;\n  height: 17px;\n  accent-color: #16887f;\n}\n\n.audit-output-mode__icon {\n  display: inline-flex;\n  width: 38px;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--audit-r-input);\n  color: #166d68;\n  background: #e5f5f3;\n}\n\n.audit-output-mode__option strong,\n.audit-output-mode__option small {\n  display: block;\n}\n\n.audit-output-mode__option strong { color: #1f3d42; font-size: 0.82rem; }\n.audit-output-mode__option small { margin-top: 3px; color: #708287; font-size: 0.7rem; line-height: 1.4; }\n\n.audit-output-mode__summary {\n  margin-top: 12px;\n  padding: 7px 10px;\n  border-radius: var(--audit-r-badge);\n  color: #17645f;\n  background: rgba(22, 136, 127, 0.08);\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n/* Split output: one tab per standard, each holding its own copy of the form. */\n.audit-split-standards {\n  margin: 0;\n}\n\n.audit-split-standards__tabs {\n  gap: 2px;\n  border-bottom: 1px solid #d6e5e5;\n  flex-wrap: wrap;\n}\n\n.audit-split-standards__tabs .nav-link {\n  border: 1px solid transparent;\n  border-bottom: none;\n  border-radius: 12px 12px 0 0;\n  padding: 8px 16px;\n  color: #64777c;\n  background: transparent;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.audit-split-standards__tabs .nav-link:hover,\n.audit-split-standards__tabs .nav-link:focus {\n  color: #16887f;\n  background: rgba(22, 136, 127, 0.08);\n}\n\n.audit-split-standards__tabs .nav-link.active {\n  color: #16887f;\n  background: #fff;\n  border-color: #d6e5e5 #d6e5e5 transparent;\n  box-shadow: 0 -2px 0 0 #16887f inset;\n}\n\n.audit-split-standards__hint {\n  margin: 10px 0 0;\n  color: #64777c;\n  font-size: 0.72rem;\n}\n\n.audit-split-standards__hint strong {\n  color: #17645f;\n}\n\n.audit-scope-banner__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.audit-scope-banner__eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--audit-accent-dark);\n  margin-bottom: 6px;\n}\n\n.audit-scope-banner__title {\n  color: #16323f;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.audit-scope-banner__subtitle {\n  font-size: 13px;\n  color: #526273;\n  max-width: 720px;\n}\n\n.audit-scope-banner__loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--audit-accent-dark);\n  white-space: nowrap;\n}\n\n.audit-scope-banner__meta,\n.audit-scope-banner__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.audit-scope-pill,\n.audit-scope-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  padding: 6px 12px;\n  border-radius: var(--audit-r-badge);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.audit-scope-pill {\n  background: #ffffff;\n  color: #20414d;\n  border: 1px solid rgba(26, 118, 126, 0.1);\n}\n\n.audit-scope-chip {\n  background: rgba(26, 118, 126, 0.12);\n  color: var(--audit-accent-dark);\n}\n\n.audit-form-select__menu {\n  z-index: 12;\n}\n\n.audit-form-select__option--is-focused {\n  background: rgba(26, 118, 126, 0.08) !important;\n}\n\n.audit-form-select__option--is-selected {\n  background: var(--audit-accent) !important;\n}\n\n/* Save draft indicator */\n.draft-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: #ffc107;\n  background: #fff3cd;\n  padding: 8px 12px;\n  border-radius: var(--audit-r-badge);\n  margin-bottom: 12px;\n}\n\n.draft-indicator::before {\n  content: '💾';\n  font-size: 14px;\n}\n\n/* Field validation feedback */\n.invalid-feedback,\n.valid-feedback {\n  display: block;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.invalid-feedback {\n  color: #dc3545;\n}\n\n.valid-feedback {\n  color: #198754;\n}\n\n.audit-notes-editor {\n  overflow: hidden;\n  border: 1px solid #d8e1ec;\n  border-radius: var(--audit-r-card);\n  background: #fff;\n}\n\n.audit-notes-editor .ql-toolbar.ql-snow,\n.audit-notes-editor .ql-container.ql-snow {\n  border: 0;\n}\n\n.audit-notes-editor .ql-toolbar.ql-snow {\n  border-bottom: 1px solid #e6edf3;\n  background: #f7fbfb;\n}\n\n.audit-notes-editor .ql-editor {\n  min-height: 240px;\n  font-size: 0.92rem;\n  line-height: 1.65;\n}\n\n.audit-evidence-panel {\n  padding: 18px;\n  border: 1px solid rgba(26, 118, 126, 0.2);\n  border-radius: var(--audit-r-card);\n  background: linear-gradient(145deg, #f8fcfc, #fff);\n}\n\n.audit-evidence-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-height: 84px;\n  color: #718096;\n  border: 1px dashed #cbd8df;\n  border-radius: var(--audit-r-input);\n}\n\n.audit-evidence-list {\n  display: grid;\n  gap: 8px;\n}\n\n.audit-evidence-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 12px 14px;\n  border: 1px solid #e1eaee;\n  border-radius: var(--audit-r-input);\n  background: #fff;\n}\n\n.audit-evidence-item span {\n  color: #718096;\n  font-size: 0.76rem;\n}\n\n/* Responsive improvements */\n@media (max-width: 576px) {\n  .audit-output-mode__options { grid-template-columns: 1fr; }\n  .audit-scope-banner {\n    padding: 16px;\n  }\n\n  .audit-scope-banner__header {\n    flex-direction: column;\n  }\n\n  .form-section {\n    padding: 16px;\n    margin-bottom: 16px;\n  }\n\n  .field-group.two-column {\n    grid-template-columns: 1fr;\n  }\n\n  .checklist-item {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .checklist-options {\n    justify-content: flex-start;\n  }\n\n  .dynamic-row {\n    padding: 12px;\n  }\n\n  .table-enhanced input[type='number'],\n  .table-enhanced input[type='text'],\n  .table-enhanced select {\n    max-width: 100%;\n  }\n}\n\n/* Inline (non-modal) form action bar. The modal render keeps its actions on\n   screen via Modal.Footer; the inline render is page-height, so Save is pinned\n   here instead of living at the bottom of a very long scroll. */\n.audit-form-sticky-actions {\n  position: sticky;\n  bottom: 0;\n  z-index: 5;\n  gap: 12px;\n  flex-wrap: wrap;\n  background: rgba(255, 255, 255, 0.94);\n  backdrop-filter: blur(6px);\n  border-bottom-left-radius: var(--audit-r-card);\n  border-bottom-right-radius: var(--audit-r-card);\n  box-shadow: 0 -6px 18px rgba(15, 23, 42, 0.06);\n}\n\n@media (max-width: 576px) {\n  .audit-form-sticky-actions {\n    justify-content: flex-end !important;\n  }\n}\n\n/* The enhanced label is a real <label> whenever it has a control to point at,\n   so it should read as clickable. */\n.form-label-enhanced label {\n  cursor: pointer;\n}\n/* ── ISCC material tables ───────────────────────────────────────────────────\n   Column COUNT varies by ISCC scheme (3 for CORSIA low-LUC, 4 for CORSIA, 5 for\n   Japan-FIT, 7 for EU, 6 for Annex I -- see utils/isccMaterialSchemes), so widths\n   cannot be pinned per nth-child as they were when there was a single fixed layout.\n   Auto table layout lets each column size to its own content, with a min-width on\n   the cells so a long GHG sentence wraps instead of collapsing a neighbour.\n\n   Cells auto-grow vertically (AutoGrowTextarea), so a long value makes its row\n   taller rather than being clipped inside a single-line input. .table-responsive\n   still supplies horizontal scroll for the widest layout on a narrow screen. */\n.audit-material-table {\n  width: 100%;\n}\n\n.audit-material-table th,\n.audit-material-table td {\n  vertical-align: top;\n  min-width: 130px;\n  word-break: break-word;\n}\n\n.audit-material-table th {\n  vertical-align: middle;\n}\n\n/* The trailing remove-row column is a fixed-size control, not content. */\n.audit-material-table th.audit-material-table__action,\n.audit-material-table td:last-child {\n  min-width: 0;\n  width: 1%;\n  white-space: nowrap;\n}\n\n/* The shell gives every textarea a 96px floor, which would make each of these\n   one-line cells nearly a hundred pixels tall. Height is driven by content via\n   AutoGrowTextarea, so the floor and the manual resize grip both go. */\n.audit-form-shell textarea.audit-material-cell-input,\ntextarea.audit-material-cell-input {\n  min-height: 0;\n  height: auto;\n  padding: 0.3rem 0.5rem;\n  overflow-y: hidden;\n  resize: none;\n  font-size: 0.82rem;\n  line-height: 1.45;\n}\n\n/* Master-backed cells (Input/Output Material, Scope) render a react-select, whose\n   menu is portalled to <body> so .table-responsive's overflow cannot clip it.\n   Wrapping and sizing live in materialSelectStyles in DocumentFormModal, because\n   react-select styles its own inner elements. */\n.audit-material-select__control {\n  background: #fff;\n}\n\n/* ── Compact select ─────────────────────────────────────────────────────────\n   Sizes an AppSelect to match `form-select-sm` / `form-control-sm` siblings in a\n   filter row. react-select styles its inner elements through emotion, whose classes\n   are single-class selectors like these, so every declaration needs !important to\n   win regardless of stylesheet order.\n\n   The control's height comes from the value container's padding, not from the\n   control's own padding — setting padding on the control does nothing visible.\n\n   Replaces the control sizing that SalesReport/AchievementForm carried inline for\n   Tom Select (the class name itself is deliberately not written out here — the\n   removal guard in src/tomSelectRemoved.test.js greps for it, and cannot tell a\n   historical comment from a live rule). Lives here rather than in that page so the next compact filter row\n   uses one tested definition instead of a second copy. Exercised by\n   e2e/tests/select-migration-smoke.spec.ts against the /dev/selects harness. */\n.app-select--sm .mb-3 {\n  margin-bottom: 0 !important;\n}\n\n.app-select--sm .app-select__control {\n  min-height: calc(1.5em + 0.5rem + 2px) !important;\n  font-size: 0.875rem !important;\n  border-radius: 0.375rem !important;\n}\n\n.app-select--sm .app-select__value-container {\n  padding: 0.125rem 0.5rem !important;\n}\n\n/* react-select draws a 20px SVG caret where Tom Select used a CSS triangle, and that\n   icon alone made the control ~34px tall against the declared 31px min-height. Shrinking\n   the icon is what actually lets min-height govern. */\n.app-select--sm .app-select__indicator {\n  padding: 0.125rem !important;\n}\n\n.app-select--sm .app-select__indicator svg {\n  width: 14px;\n  height: 14px;\n}\n\n/* react-select's input wrapper carries its own margin and vertical padding, which stacks\n   on top of the value container's — without zeroing it the control renders ~34px and the\n   31px min-height never governs. */\n.app-select--sm .app-select__input-container {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.app-select--sm .app-select__menu {\n  font-size: 0.875rem;\n}\n\n/* ── Truncated select menu footer ───────────────────────────────────────────\n   Shown when a menu paints fewer options than matched (see makeMenuList in\n   components/common/select/fieldChrome.jsx). Tom Select cut its list at 50 silently;\n   this says so instead.\n\n   Sticky rather than appended: MenuList is the scroll container, so a static footer\n   would sit below 50 rows where nobody scrolls to find it. Pinned to the bottom edge, it\n   is the one thing still visible after the list runs out — which is exactly when the\n   reader is wondering where their client went.\n\n   pointer-events: none so it can never swallow a click meant for the option beneath it\n   as the list scrolls under it. */\n.app-select__menu-truncation {\n  position: sticky;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-top: 2px;\n  padding: 7px 12px;\n  border-top: 1px solid #e6edf3;\n  background: linear-gradient(180deg, rgba(247, 251, 251, 0.92) 0%, #f7fbfb 42%);\n  backdrop-filter: blur(2px);\n  color: #64777c;\n  font-size: 0.72rem;\n  line-height: 1.45;\n  pointer-events: none;\n  user-select: none;\n}\n\n.app-select__menu-truncation strong {\n  color: #17645f;\n  font-weight: 700;\n}\n\n.app-select__menu-truncation-icon {\n  flex: 0 0 auto;\n  color: #16887f;\n  opacity: 0.75;\n}\n\n/* The compact variant's menu is a size down, so its footer follows. */\n.app-select--sm .app-select__menu-truncation {\n  padding: 5px 10px;\n  font-size: 0.68rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
